import { TableColumnConfig } from '@shared/model';

export const EMPTY_OPTION = { label: 'N/A', value: 'null' };

export const ZZ_SKILL_CODE_OPTION = { label: 'ZZ', value: 'null' };

export const tableConfig: TableColumnConfig[] = [
  {
    header: 'Alerts',
    field: 'alerts',
    styles: { minWidth: '190px' },
    isFrozen: true,
  },
  {
    header: 'Queue',
    isFrozen: true,
    field: 'userName',
    styles: { minWidth: '190px' },
    isSortable: true,
    filterTemplate: 'multiselect',
    filtering: true,
    filterByKey: 'user/userId',
    sortByKey: 'user/name',
  },
  {
    header: 'Urgency',
    field: 'urgency',
    styles: { minWidth: '140px' },
    isSortable: true,
    filterTemplate: 'multiselect',
  },
{
    header: 'Post Clinical Review Time',
    field: 'anticipatedManualDecisionDate',
    styles: { minWidth: '220px' },
    isSortable: true,
  },
  {
    header: 'Time Since Request Received',
    field: 'requestReceivedDate',
    styles: { minWidth: '220px' },
    isSortable: true,
  },
  {
    header: 'Client',
    field: 'tenantName',
    styles: { minWidth: '150px' },
    isSortable: true,
    filterTemplate: 'multiselect',
  },
  {
    header: 'Member',
    field: 'memberName',
    styles: { minWidth: '200px' },
    isSortable: true,
    filterTemplate: 'input',
    multiFilterReadBy: 'memberName,memberSubscriberNumber',
    multiFilterProperties: ['memberName', 'memberSubscriberNumber'],
  },
  {
    header: 'Auth #',
    field: 'authorizationNumber',
    styles: { minWidth: '150px' },
    isSortable: true,
    filterTemplate: 'input',
  },
  {
    header: 'Skill',
    field: 'skillCode',
    styles: { minWidth: '140px' },
    isSortable: true,
    filterTemplate: 'multiselect',
    filtering: true,
  },
  {
    header: 'State',
    field: 'memberState',
    styles: { minWidth: '90px' },
    isSortable: true,
    filterTemplate: 'multiselect',
    filtering: true,
  },
  {
    header: 'Service Provider',
    field: 'providerNpi',
    styles: { minWidth: '180px' },
    isSortable: true,
    filterTemplate: 'input',
    multiFilterReadBy: 'providerNpi,providerName',
    multiFilterProperties: ['providerNpi', 'providerName'],
  },
  {
    header: 'Service Request Type',
    field: 'requestType',
    styles: { minWidth: '180px' },
    isSortable: true,
    filterTemplate: 'multiselect',
    filtering: true,
  },
  {
    header: 'Subtype',
    field: 'orderSubtype',
    styles: { minWidth: '170px' },
    isSortable: true,
    filterTemplate: 'multiselect',
    filtering: true,
  },
  {
    header: 'SL Status',
    field: 'serviceLineStatus',
    styles: { minWidth: '150px' },
    isSortable: true,
    filterTemplate: 'multiselect',
    filtering: true,
  },
  {
    header: 'Status Reason',
    field: 'serviceLineStatusReason',
    styles: { minWidth: '150px' },
    isSortable: true,
    filterTemplate: 'multiselect',
    filtering: true,
  },
  {
    header: 'Add Info',
    field: 'additionalInformationReceived',
    styles: { minWidth: '110px' },
    isSortable: true,
  },
  {
    header: 'Time in Queue',
    field: 'routedDate',
    styles: { minWidth: '155px' },
    isSortable: true,
  },
  {
    header: 'Quality Check Completed',
    field: 'isQualityCheckComplete',
    styles: { minWidth: '130px' },
    isSortable: true,
    filterTemplate: 'dropdown',
  },
];
